<template>
  <layout-user>
    <b-row class="h-100">
      <b-colxx xxs="12" md="10" class="mx-auto my-auto">
        <b-card class="auth-card" no-body>
          <div class="position-relative image-side">
            <p class="text-white h5 font-style">歡迎來到<br />金旺宏形象網站管理後台</p>
            <p class="white mb-0 font-style">請先登入系統</p>
          </div>
          <div class="form-side custom position-relative">
            <router-view />

            <footer class="copyright">Powerd By CONQUER TECHNOLOGY CO., LTD.</footer>
          </div>
        </b-card>
      </b-colxx>
    </b-row>
  </layout-user>
</template>

<script>
import LayoutUser from '@/layouts/User.vue';

export default {
  name: 'PageAuthIndex',

  components: {
    LayoutUser,
  },
};
</script>
